import FormaterColorWeek from '../Components/Formaters/FormaterColorWeek';
import FormaterColorFact from '../Components/Formaters/FormaterColorFact';
import FormaterDate from '../Components/Formaters/FormaterDate';
import FormaterString from '../Components/Formaters/FormaterString';
import FormaterID from '../Components/Formaters/FormaterID';
import FormaterNapr from '../Components/Formaters/FormaterNapr';
//import { SelectColumn } from 'react-data-grid';
import * as api from '../api/apiFunc';

const lday = 50;
function CustomHeader(item) {
    return api.CustomFormatter(item.column.name,item.column.shortname,'white','#343433',0.7)
}

export const columnsMainData = [
    {
        key: 'StationCode', name: 'Код станции', resizable: true, frozen: false, editable: true, width: 90, _type: 0,
        headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.StationCode; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'StationName', name: 'Наименование станции', resizable: true, editable: true, width: 150, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.StationName; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'incomeCount', name: 'Вход.вагоны', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.incomeCount; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'outgoingCount', name: 'Исх.вагоны', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.outgoingCount; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'Lat', name: 'Широта', resizable: true, editable: true, width: 95, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.Lat; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'Lng', name: 'Долгота', resizable: true, editable: true, width: 95, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.Lng; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'ID', name: 'ID', frozen: false, resizable: true, width: 10, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.ID; return <FormaterID value={value} Align={'left'} Src='static/img/add_row.png' Width='30%' Height='40%' Color='black' FontSize = '90%'  />; }
    },
    
]

export const columnsSubData = [
    {
        key: 'napr', name: 'Напр.', resizable: true, frozen: false, editable: true, width: 20, _type: 0,
        headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.napr; return <FormaterNapr value={value} Align={'center'} SrcIn='static/img/in.png' SrcOut='static/img/out.png'  Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'nomv', name: 'Номер вагона', resizable: true, frozen: false, editable: true, width: 100, _type: 0,
        headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.nomv; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'dor', name: 'Дорога', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.dor; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'kodstdis', name: 'Код. ст. дисл.', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.kodstdis; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'nazvstdis', name: 'Станция дисл.', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.nazvstdis; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'datop', name: 'Дата операции', resizable: true, editable: true, width: 120, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.datop; return <FormaterDate value={value} Time={true} Align={'left'} Color='black' FontSize='90%' />}
    },
    {
        key: 'oper', name: 'Операция', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.oper; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'kodgruza', name: 'Код груза', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.kodgruza; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'nazvgruza', name: 'Назв. груза', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.nazvgruza; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'nazvpol', name: 'Получатель', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.nazvpol; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'nazvotpr', name: 'Отправитель', resizable: true, editable: true, width: 100, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.nazvotpr; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'ID', name: 'ID', frozen: false, resizable: true, width: 50, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.ID; return <FormaterID value={value} Align={'left'} Src='static/img/add_row.png' Width='30%' Height='40%' Color='black' FontSize = '90%'  />; }
    },
  /* {
        key: 'kodstnazn', name: 'kodstnazn', frozen: false, resizable: true, width: 50, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.kodstnazn; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'kodpol', name: 'kodpol', frozen: false, resizable: true, width: 50, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const value = props.row.kodpol; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },*/
    
]

export const columnsFilter = [
    { key: 'activ', name: 'Актив', _typecolumn: 'mult', _picklist: "Activ", _typedata: 55, _filterval: "", },
    { key: 'napr', name: 'Направление грузов', _typecolumn: 'mult', _picklist: "Napr", _typedata: 10, _filterval: "", },
    { key: 'sostav', name: 'Состав', _typecolumn: 'mult', _picklist: "sostav", _typedata: 55, _filterval: "", },
    { key: 'marshrut', name: 'Маршрут', _typecolumn: 'mult', _picklist: "marshrut", _typedata: 55, _filterval: "", },
    { key: 'stancprim', name: 'Станция примыкания', _typecolumn: 'mult', _picklist: "stancPrim", _typedata: 55, _filterval: "", },
    { key: 'oper', name: 'Операция', _typecolumn: 'mult', _picklist: "Oper", _typedata: 55, _filterval: "", },
    { key: 'date', name: 'Период даты операций с ', _typecolumn: null, _picklist: null, _typedata: 5, _filterval: "", },
    { key: 'nazvpol', name: 'Получатель', _typecolumn: 'mult', _picklist: "Nazvpol", _typedata: 10, _filterval: "", },
    { key: 'nazvotpr', name: 'Отправитель', _typecolumn: 'mult', _picklist: "Nazvotpr", _typedata: 10, _filterval: "", },
    { key: 'stdis', name: 'Cтанция дислокации', _typecolumn :  'mult', _picklist : "Stdis", _typedata : 10, _filterval: "", },
    { key: 'nazvgruza', name: 'Наименование груза', _typecolumn: 'mult', _picklist: "Nazvgruza", _typedata: 10, _filterval: "", },
    { key: 'dor', name: 'Дорога', _typecolumn: 'mult', _picklist: "Dor", _typedata: 10, _filterval: "", },
    { key: 'nomv', name: 'Номер вагона', _typecolumn: null, _picklist: null, _typedata: 20, _filterval: "", },
    { key: 'marsh', title: 'Долгостоящие вагоны :', name: 'Маршрут', _typecolumn: 'checkbox2', _picklist: null, _typedata: null, _filterval: "", },
    { key: 'single', title: '', name: 'Одиночные', _typecolumn: 'checkbox2', _picklist: null, _typedata: null, _filterval: "", },
    { key: 'st', name: 'Станции с грузами', _typecolumn: 'checkbox', _picklist: null, _typedata: null, _filterval: "", },
  ]
  
export const columnsMainDataOLD = [
    { key: 'vidp', name: 'Т',frozen : true,resizable: false,width:30,maxWidth:30,_type:0,headerRenderer: CustomHeader },
    {
        key: 'taskp', name: 'Задача', resizable: true, frozen: true, editable: false, width: 570, _type: 0,
        headerRenderer: CustomHeader,
        summaryFormatter() { return <strong>Итого</strong>; },
        formatter(props) { const value = props.row.taskp; return <FormaterString value={value} Align={'left'} Color='black' FontSize = '90%'  />; }
    },
    {
        key: 'datan', name: 'Начало', resizable: true, editable: false, width: 120, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const val = props.row.datan;
            return <FormaterDate value={val} Align={'center'} Color='black' FontSize = '100%' />;
          }
    },
    {
        key: 'datak', name: 'Конец', resizable: true, editable: false, width: 120, _type: 0, headerRenderer: CustomHeader,
        formatter(props) { const val = props.row.datak;
            return <FormaterDate value={val} Align={'center'} Color='black' FontSize = '100%' />;
          }
    },
    { key: 'planh', name: 'План,ч.',resizable: true,editable: false,width:60,maxWidth:60,_type:0,headerRenderer: CustomHeader ,
    summaryFormatter({ row }) { return <FormaterColorFact FKey={'facth'} Value={row.planh} datan={row.datan} summary={1} Align={'center'} Color='black' FontSize='90%' /> },
    formatter(props) { const value = props.row.planh; return <FormaterColorFact FKey={'facth'} Value={value} plan = {null} datan={props.row.datan} summary={0} Align={'center'} Color='black' FontSize='90%' />; }
    },
    { key: 'facth', name: 'Факт,ч.', resizable: true, editable: false, width: 60,maxWidth:60, _type: 1, headerRenderer: CustomHeader,
    summaryFormatter({ row }) { return <FormaterColorFact FKey={'facth'} Value={row.facth} datan={row.datan} summary={1} Align={'center'} Color='black' FontSize='90%' /> },
    formatter(props) { const value = props.row.facth; return <FormaterColorFact FKey={'facth'} Value={value} plan = {props.row.plan} datan={props.row.datan} summary={0} Align={'center'} Color='black' FontSize='90%' />; }
    },
    { key: 'done', name: 'Вып.',resizable: true,editable: false,width:40,maxWidth:40,_type:0,headerRenderer: CustomHeader,
    summaryFormatter({ row }) { return <FormaterColorFact FKey={'done'} Value={row.done} datan={row.datan} summary={1} Align={'center'} Color='black' FontSize='90%' /> },
    formatter(props) { const value = props.row.done; return <FormaterColorFact FKey={'done'} Value={value} plan = {null} datan={props.row.datan} summary={0} Align={'center'} Color='black' FontSize='90%' />; }
    },
    { key: 'd01', name: '1', resizable: false, editable: true, width: lday,maxWidth:lday, _type: 1,headerRenderer: CustomHeader,
        summaryFormatter({ row }) { return <FormaterColorWeek FKey={'d01'} Value={row.d01} datan={row.datan} summary={1} Align={'center'} Color='black' FontSize='90%' /> },
        formatter(props) { const value = props.row.d01; return <FormaterColorWeek FKey={'d01'} Value={value} category={props.row.category_id} datan={props.row.datan} summary={0} Align={'center'} Color='black' FontSize='90%' />; }
    },
]

export const columnsAppTasks = [
    { key: 'application_id', name: 'App_id',resizable: true,editable: false,width:120 },
    { key: 'Name', name: 'Наименование проекта',resizable: true,editable: false,width:600 },
    { key: 'Mnem', name: 'Мнемоника',resizable: true,editable: true},
  /*  { key: 'Author', name: 'Автор',resizable: true,editable: true,width:240 },
    { key: 'Version', name: 'Версия',resizable: true,editable: true,width:70 },
    { key: 'Date_creation', name: 'Дата создания',resizable: true,editable: true,width:140 },
    { key: 'Date_update', name: 'Дата последнего обновления',resizable: true,editable: true,width:140 },*/
]

export const columnsUsersAccess = [
    { key: 'Group_id', name: 'Ключ',resizable: true,width:140 },
    { key: 'Sam_name', name: 'Название в системе AD',resizable: true,editable: false,width:250 },
    { key: 'Group_dn', name: 'Идентификатор в системе AD',resizable: true,editable: false,width:220 },
    { key: 'It_group_id', name: 'Группа ИТ',resizable: true,editable: false,width:220 },
    { key: 'Group_Note', name: 'Описание в группе',resizable: true,editable: false,width:220 },
]

export const columnsElementsList = [
    { key: 'application_id', name: 'Ключ',resizable: true,width:140 },
    { key: 'Tree_name', name: 'Название элемента меню',resizable: true,width:250 },
    { key: 'Parent_tree_name', name: 'Название родительского элемента меню',resizable: true },
    { key: 'Name', name: 'Доступ',resizable: true },
]

